import { fetchData, symbolsPath } from '../api';


export async function listSymbols(authConfig) {
    return await fetchData(symbolsPath());
}
